import Checkbox from '@repo/ui/checkbox'
import { useMutation } from '@tanstack/react-query'

import {
  blockAffectedStaffTravelExpenses,
  unblockAffectedStaffTravelExpenses
} from '../../../api/affected-staffs/travel-expenses'
import {
  blockMissionToStaffTravelExpenses,
  unblockMissionToStaffTravelExpenses
} from '../../../api/mission-to-staffs/travel-expenses'
import { TravelExpensesSalaryStaff } from '../../../lib/types/models/travel-expenses/travel-expenses-staff'

type Props = {
  travelExpenseSalaryStaff: TravelExpensesSalaryStaff
  onBlockSuccess: () => void
  onUnblockSuccess: () => void
}

const TravelExpensesSalaryStaffTableBlock = ({
  travelExpenseSalaryStaff,
  onBlockSuccess,
  onUnblockSuccess
}: Props) => {
  const blockAffectedStaffTravelExpensesMutation = useMutation({
    mutationFn: blockAffectedStaffTravelExpenses,
    onSuccess: () => onBlockSuccess()
  })

  const unblockAffectedStaffTravelExpensesMutation = useMutation({
    mutationFn: unblockAffectedStaffTravelExpenses,
    onSuccess: () => onUnblockSuccess()
  })

  const blockMissionToStaffTravelExpensesMutation = useMutation({
    mutationFn: blockMissionToStaffTravelExpenses,
    onSuccess: () => onBlockSuccess()
  })

  const unblockMissionToStaffTravelExpensesMutation = useMutation({
    mutationFn: unblockMissionToStaffTravelExpenses,
    onSuccess: () => onUnblockSuccess()
  })

  const travelExpenseBlocked =
    'affectedStaff' in travelExpenseSalaryStaff && travelExpenseSalaryStaff.affectedStaff
      ? travelExpenseSalaryStaff.affectedStaff.travelExpensesBlocked
      : 'missionToStaff' in travelExpenseSalaryStaff && travelExpenseSalaryStaff.missionToStaff
        ? travelExpenseSalaryStaff.missionToStaff.travelExpensesBlocked
        : false
  return (
    <Checkbox
      checked={!travelExpenseBlocked}
      onChange={async (newValue) => {
        if (
          'affectedStaff' in travelExpenseSalaryStaff &&
          travelExpenseSalaryStaff.affectedStaff
        ) {
          if (newValue)
            await unblockAffectedStaffTravelExpensesMutation.mutateAsync(
              travelExpenseSalaryStaff.affectedStaff.id
            )
          else
            await blockAffectedStaffTravelExpensesMutation.mutateAsync(
              travelExpenseSalaryStaff.affectedStaff.id
            )
        } else if (
          'missionToStaff' in travelExpenseSalaryStaff &&
          travelExpenseSalaryStaff.missionToStaff
        ) {
          if (newValue)
            await unblockMissionToStaffTravelExpensesMutation.mutateAsync(
              travelExpenseSalaryStaff.missionToStaff.id
            )
          else
            await blockMissionToStaffTravelExpensesMutation.mutateAsync(
              travelExpenseSalaryStaff.missionToStaff.id
            )
        }
      }}
    />
  )
}

export default TravelExpensesSalaryStaffTableBlock
